<template>
  <div class="c-related-links">
    <p
      v-dompurify-html="$t('product.relatedLinks')"
      class="o-typography o-typography__title1 c-related-links__title u-mb-15"
    ></p>
    <a
      v-for="({ description, url }, index) in relatedLinks"
      :key="index"
      class="c-related-links__link o-typography o-typography--underline o-typography__body2"
      :href="url"
      target="_blank"
    >
      {{ description }}
    </a>
  </div>
</template>

<script>
  export default {
    name: 'RelatedLinks',
    props: {
      relatedLinks: {
        type: Array,
        required: true,
      },
    },
  };
</script>
